module.exports = __webpack_public_path__ + "img/7982312.jpg";